import React from "react";
import { format } from "date-fns";
import { DateFormat } from "utilities/dist/invoice/constants";
import { buildTabcId } from "utilities/dist/customer/helpers";

import CustomerComponentGridActions from "./components/grid-actions";
import { GridProductPriceTierSelector } from "./components/grid-price-tier-selector";
import { parseServerTimestampForClient } from "../common/helpers";

export const CustomerGridColumns = [
    {
        headerName: "ID",
        field: "id",
        maxWidth: 0,
    },
    {
        headerName: "Name",
        field: "name",
        minWidth: 150,
        filter: "agTextColumnFilter",
    },
    {
        headerName: "TABC ID",
        field: "tabc_id",
        minWidth: 100,
        valueGetter: function ({ data }) {
            return !data ? null : buildTabcId(data);
        },
        filter: "agTextColumnFilter",
    },
    {
        headerName: "Address",
        field: "address",
        minWidth: 200,
        valueGetter: function ({ data }) {
            if (!data) return null;

            return `${data.address} ${data.city}, ${data.zip}`;
        },
        cellRenderer: function ({ data }) {
            if (!data) return null;

            return (
                <>
                    {data.address}
                    <br />
                    {data.city}, {data.zip}
                </>
            );
        },
        filter: "agTextColumnFilter",
    },
    {
        headerName: "Tier",
        editable: true,
        field: "product_price_tier_id",
        minWidth: 100,
        filter: false,
        sortable: false,
        cellEditor: GridProductPriceTierSelector,
        cellEditorParams: {
            cellWidth: 300,
        },
        valueGetter: function ({ data }) {
            if (!data) return null;
            return data.productPriceTier?.name || "Base Tier";
        },
    },
    {
        headerName: "COD",
        field: "cash_on_delivery",
        minWidth: 50,
        valueGetter: function ({ data }) {
            if (!data) return null;

            return data.cash_on_delivery ? "Yes" : "No";
        },
        filter: "agTextColumnFilter",
    },
    {
        headerName: "Contact Name",
        field: "contact_name",
        minWidth: 100,
        filter: "agTextColumnFilter",
    },
    {
        headerName: "Contact Info",
        field: "contact_email",
        minWidth: 100,
        valueGetter: function ({ data }) {
            if (!data) return null;
            const info = [data.contact_email, data.contact_phone];

            return info.filter(Boolean).join(", ");
        },
        cellRenderer: function ({ data }) {
            if (!data) return null;
            if (!data) return null;
            return (
                <>
                    {data.contact_email ?? ""}
                    <br />
                    {data.contact_phone ?? ""}
                </>
            );
        },
        filter: "agTextColumnFilter",
    },
    {
        headerName: "Actions",
        field: "actions",
        cellRenderer: CustomerComponentGridActions,
        minWidth: 120,
        filter: false,
    },
    {
        headerName: "Users",
        field: "customer_users",
        minWidth: 50,
        valueGetter: function ({ data }) {
            if (!data) return null;
            return `${data.customerUser?.length || 0}`;
        },
        filter: "agNumberColumnFilter",
    },
    {
        headerName: "Created At",
        field: "created_at",
        valueFormatter: function ({ data }) {
            return !data
                ? null
                : format(parseServerTimestampForClient(data.created_at), DateFormat);
        },
    },
];
